(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[706],{

/***/ 82904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders/order-status",
      function () {
        return __webpack_require__(33169);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dm": function() { return /* binding */ orderPaginationAnalytics; },
/* harmony export */   "Up": function() { return /* binding */ orderBackToTopAnalytics; },
/* harmony export */   "d$": function() { return /* binding */ loadMoreAnalytics; },
/* harmony export */   "eL": function() { return /* binding */ continueAnalytics; },
/* harmony export */   "md": function() { return /* binding */ orderDetailsAnalytics; }
/* harmony export */ });
/* unused harmony export orderSignOutAnalytics */
const { pushAnalyticsObjToDataLayer , getAnalyticLinkUrl  } = __webpack_require__(34326);
const orderDetailsAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open", url = arguments.length > 1 ? arguments[1] : void 0;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:order details"),
        eventName: "my account:orders:".concat(orderType, " orders:order details"),
        eventType: "navigation",
        internalLinkName: "order details",
        internalLinkPosition: "my account",
        internalLinkType: "my account:submitted",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: getAnalyticLinkUrl(url)
    };
    return JSON.stringify(eventInfo);
};
const continueAnalytics = (url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:continue shopping",
        eventName: "my account:orders:continue shopping",
        eventType: "navigation",
        internalLinkName: "continue shopping",
        internalLinkPosition: "my order",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:open orders",
        internalLinkURL: url ? url.indexOf("http") === -1 ? window.location.origin : "" : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderSignOutAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:sign out",
        eventName: "my account:orders:sign out",
        eventType: "navigation",
        internalLinkName: "sign out",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders",
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const loadMoreAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:load more"),
        eventName: "my account:orders:".concat(orderType, " orders:load more"),
        eventType: "navigation",
        internalLinkName: "load more",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderBackToTopAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:back to top"),
        eventName: "my account:orders:".concat(orderType, " orders:back to top"),
        eventType: "navigation",
        internalLinkName: "back to top",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    return JSON.stringify(eventInfo);
};
const orderPaginationAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open", count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:pagination"),
        eventName: "my account:orders:".concat(orderType, " orders:pagination"),
        eventType: "navigation",
        internalLinkName: count,
        internalLinkPosition: "my account",
        internalLinkType: "my account:pagination bottom",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    return JSON.stringify(eventInfo);
};


/***/ }),

/***/ 33169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ order_status; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 93 modules
var AemGrid = __webpack_require__(55064);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./components/AccountsLayoutNonLoggedIn/index.module.scss
var index_module = __webpack_require__(1493);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
;// CONCATENATED MODULE: ./components/AccountsLayoutNonLoggedIn/index.jsx







const AccountsLayoutNonLoggedIn = (param)=>{
    let { i18n , title , user , isAuth , logout , redirect , ...props } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    var _activeTab;
    const [activeTab, setActive] = (0,react.useState)((_activeTab = props.activeTab) !== null && _activeTab !== void 0 ? _activeTab : 2);
    const [origin, setOrigin] = (0,react.useState)("");
    const [isMobile, setIsMobile] = (0,react.useState)(width <= 1203);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { authModal: { show  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const data = [
        {
            title: "Sign In"
        },
        {
            title: "Create Account"
        },
        {
            title: "Orders"
        }
    ];
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 1024);
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        setOrigin(window.location.origin);
    }, []);
    (0,react.useEffect)(()=>{
        if (!show) setActive(2);
    }, [
        show
    ]);
    const handleChange = (index)=>{
        setActive(index);
        if (index === 0 || index === 1) {
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true,
                active: index
            }));
        }
    };
    const handleClick = (index)=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: index
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).accountTabsWrapper, " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "account-tabs__main-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                    className: "col-lg-3 account-tabs__nav-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "account-tabs__nav",
                        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "kf-user-name",
                                    className: "account-tabs__message",
                                    tabIndex: "0",
                                    role: "alert",
                                    children: "".concat(i18n.yourKohlerAccount)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "kf-user-name",
                                    className: "account-tabs__text",
                                    tabIndex: "0",
                                    role: "alert",
                                    onClick: ()=>handleClick(0),
                                    children: "".concat(i18n.signIn)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-tabs__horizontal-line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "kf-user-name",
                                    className: "account-tabs__text",
                                    tabIndex: "0",
                                    role: "alert",
                                    onClick: ()=>handleClick(1),
                                    children: "".concat(i18n.createAccount)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-tabs__horizontal-line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "kf-user-name",
                                    className: "account-tabs__text account-tabs__active",
                                    tabIndex: "0",
                                    role: "alert",
                                    children: "".concat(i18n.orders)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-tabs__horizontal-line"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "account-tabs__dropdown",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "account-tabs__heading",
                                    children: i18n.yourKohlerAccount
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    id: "account-tab",
                                    data: data === null || data === void 0 ? void 0 : data.map((item)=>item.title),
                                    value: data[activeTab] ? data[activeTab].title : "",
                                    label: "My Account",
                                    onChange: (val)=>handleChange(data.findIndex((obj)=>obj.title === val))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "col-lg-9 account-tabs__wrapper-nav",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "account-tabs__content",
                        children: props.children
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_AccountsLayoutNonLoggedIn = (AccountsLayoutNonLoggedIn);

// EXTERNAL MODULE: ./components/Shared/OrderStatus/v1/index.module.scss
var v1_index_module = __webpack_require__(96012);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
// EXTERNAL MODULE: ./utils/orders.js + 1 modules
var orders = __webpack_require__(84219);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/Shared/OrderHistory/v1/analytics.js
var analytics = __webpack_require__(57050);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderTile.jsx











const OrderTile = (props)=>{
    const { i18n , type , data , info , orderType , authorData , ...restProps } = props;
    const { orderNo ="" , orderStatus ="" , orderDate ="" , totalItems ="" , orderTotal ="" , isImported =false , migratedOrderDate =""  } = data;
    const { currencySign , orderDetailsUrl  } = info;
    const orderDetailsPage = "".concat(orderDetailsUrl, "?orderNumber=").concat(orderNo);
    const [loading, setLoading] = (0,react.useState)(false);
    const checkOrder = async ()=>{
        setLoading(true);
        let orderdetailsURL = "";
        orderdetailsURL = await (0,utils/* getOrderDetailsUrlNonLoggedIn */.uR)(orderNo);
        window.location.href = orderdetailsURL;
        setLoading(false);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "order-status__order-tile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order-status__details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "order-status__order-no",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__label",
                                children: "".concat(i18n.order, " #")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__value",
                                children: "".concat(isImported ? "SK-" + orderNo : orderNo)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "order-status__date",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__label",
                                children: type === "openOrders" ? i18n.orderCreatedOn((ref = authorData === null || authorData === void 0 ? void 0 : authorData.columnOne) !== null && ref !== void 0 ? ref : null) : i18n.orderCreatedOn(null)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__value",
                                children: isImported ? moment_default()(Date.parse(migratedOrderDate)).format("MM/DD/YYYY") : moment_default()(Date.parse(orderDate)).format("MM/DD/YYYY")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "order-status__items",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__label",
                                children: i18n.items
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__value",
                                children: totalItems
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "order-status__total",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__label",
                                children: i18n.orderTotal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__value",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: orderTotal,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: restProps.orderTotal === 0 ? 0 : 2,
                                    fixedDecimalScale: true,
                                    thousandsGroupStyle: "lakh"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "order-status__status",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__label",
                                children: i18n.orderStatus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__value",
                                children: orderStatus
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                ariaLabel: "".concat(type === "openOrders" ? i18n.openOrders : i18n.pastOrders, " ").concat(i18n.viewOrder, " ").concat(orderNo),
                className: "gbh-data-layer",
                "data-gbh-data-layer": (0,analytics/* orderDetailsAnalytics */.md)(orderType === "openOrders" ? "open" : "past", orderDetailsPage),
                customClass: "order-status__view-order",
                size: "small",
                type: "ghost",
                role: "button",
                onClick: checkOrder,
                label: i18n.orderDetails,
                loading: loading
            })
        ]
    });
};
/* harmony default export */ var v1_OrderTile = (OrderTile);

// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatus.view.jsx












// import { log } from "@Services/logger.service"
const OrderStatus = (param)=>{
    let { i18n , cartcontactDetails =[] , ...props } = param;
    const [data, setData] = (0,react.useState)({
        orderNo: {
            value: ""
        }
    });
    const [orderDetails, setOrderDetails] = (0,react.useState)(null);
    const [loading, setLoading] = (0,react.useState)(false);
    const [initialConfig, setInitialConfig] = (0,react.useState)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [isMobile, setIsMobile] = (0,react.useState)(width <= 1203);
    const [isValid, setIsValid] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setInitialState(config);
        });
    }, []);
    const setInitialState = async (config)=>{
        const accountSettingsPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.accountSettingsPath", ""));
        const myFavoritesPagePath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myFavoritesPagePath", ""));
        const orderHistoryPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderHistoryPath", ""));
        const myProductsPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myProductsPath", ""));
        const myServicesPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myServicesPath", ""));
        const contactUspath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "apiEndpoints.contactUsPath", ""));
        const orderDetailsUrl = get_default()(config, "general.orderDetailsPath", "");
        const continueShopUrl = get_default()(config, "general.continueShopPath", "");
        const currencySign = get_default()(config, "internationalization.currencySign", "");
        setInitialConfig({
            accountSettingsPath,
            myFavoritesPagePath,
            orderHistoryPath,
            myProductsPath,
            myServicesPath,
            orderDetailsUrl,
            continueShopUrl,
            currencySign,
            contactUspath
        });
    };
    const handleSubmit = async ()=>{
        let valid = true;
        const { orderNo  } = data;
        if (!orderNo.value) {
            valid = false;
        }
        if (valid) {
            setLoading(true);
            const res = await (0,orders/* fetchOrderDataByOrderId */.KV)(orderNo.value);
            const { order_detail ={}  } = res;
            setLoading(false);
            if (Object.keys(order_detail).length) {
                let shipments = order_detail.shipments;
                const orderDate = new Date(order_detail.orderDate);
                const orderDetails = {
                    orderNo: get_default()(order_detail, "orderNumber", ""),
                    totalItems: shipments.reduce((a, b)=>{
                        return a + Math.trunc(b.itemCount);
                    }, 0),
                    orderStatus: get_default()(order_detail, "orderStatus", ""),
                    orderDate: "".concat(orderDate.toLocaleString("default", {
                        month: "long"
                    }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
                    orderTotal: Number(get_default()(order_detail, "order_summary.totalAmount", 0)).toFixed(2)
                };
                setOrderDetails(orderDetails);
            } else {
                setOrderDetails({});
                setLoading(false);
            }
        }
    };
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 1024);
    }, [
        width
    ]);
    const checkIsValid = (orderId)=>{
        if (orderId !== "") {
            const orderIdRegEx = /^[D][A-Z0-9-]+$/;
            const isMatch = orderIdRegEx.test(orderId);
            if (isMatch) setIsValid(true);
            else setIsValid(false);
        } else {
            setIsValid(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AccountsLayoutNonLoggedIn, {
            title: i18n.title,
            i18n: i18n,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (v1_index_module_default()).orderStatusWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row no-gutters",
                    children: [
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-status__heading",
                            children: i18n.orders
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "order-status__form",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-status__form-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "order-status__help-text",
                                            children: "Check your order detail"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "order-status__help-description",
                                            children: "Enter your order ID below to check order detail. "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__form-div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "kf-order-status-number",
                                                    type: "text",
                                                    name: "orderNo",
                                                    value: data.orderNo.value,
                                                    placeholder: "".concat(i18n.orderID),
                                                    label: "".concat(i18n.orderID),
                                                    customClass: "order-status__input",
                                                    onChange: (e)=>{
                                                        setData({
                                                            orderNo: {
                                                                value: e.target.value
                                                            }
                                                        });
                                                        checkIsValid(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    customClass: "order-status__find-btn",
                                                    type: "ghost",
                                                    flexible: true,
                                                    label: i18n.checkOrder,
                                                    onClick: handleSubmit,
                                                    role: "button",
                                                    loading: loading,
                                                    disabled: !data.orderNo.value || loading || !isValid
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !isValid ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-status__error",
                                    children: "Invalid order ID. Please enter a valid order ID."
                                }) : null
                            ]
                        }),
                        orderDetails && Object.keys(orderDetails).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-status__header",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-status__title",
                                        children: "Your Order"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderTile, {
                                    data: orderDetails,
                                    info: initialConfig,
                                    i18n: i18n
                                })
                            ]
                        }),
                        orderDetails && Object.keys(orderDetails).length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-status__no-result",
                            children: i18n.noResult
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var OrderStatus_view = (OrderStatus);

// EXTERNAL MODULE: ./utils/localization.js
var localization = __webpack_require__(64069);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatusFiller.jsx


const OrderStatusFiller = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "orderstatus",
            className: " aem-GridColumn aem-GridColumn--default--12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order-status container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-lg-12 order-status__form-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__banner",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-status__header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__title",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__title shimmer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__desc",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-status__form",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-status__form-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Input_inputFieldWrapper__nt6o0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " input-field ",
                                                id: "kf-order-status-number-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "input-field__value",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__input shimmer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "shimmer-loading__para shimmer"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "order-status__help-text gbh-data-layer",
                                            role: "link",
                                            tabIndex: "0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__para shimmer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Input_inputFieldWrapper__nt6o0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " input-field ",
                                                id: "kf-order-status-email-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "input-field__value",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "shimmer-loading__input shimmer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "shimmer-loading__para shimmer"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Button_buttonWrapper__9Vvy_ kf-react-button button large black flexible order-status__find-btn ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "shimmer-loading__button shimmer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Recaptcha_reCatichWrapper__pIvbo",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-20 mb-20 recaptcha-links",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "gpolicies gbh-data-layer",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        href: "https://policies.google.com/privacy",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "gpolicies gbh-data-layer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-status__support",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "shimmer-loading__para shimmer"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_OrderStatusFiller = (OrderStatusFiller);

;// CONCATENATED MODULE: ./components/Shared/OrderStatus/v1/OrderStatus.jsx




















const OrderStatus_OrderStatus = (param)=>{
    let { data  } = param;
    var ref;
    // #ToDo Contact number needs to get from authdata
    const contactNumber = (ref = data === null || data === void 0 ? void 0 : data.contactnumber) !== null && ref !== void 0 ? ref : "NIL";
    const { cartcontactDetails =[]  } = data !== null && data !== void 0 ? data : {};
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { isCartLoading =false  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [config, setInitialConfig] = (0,react.useState)({});
    const { homeUrl  } = config;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            seti18n((0,localization/* getTranslations */.F)(t));
            setInitialState(config);
        });
        if (!isCartLoading) {
            dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
            dispatch((0,cartSlice/* getCart */.dv)()).unwrap().then((rsp)=>{
                var ref;
                if ((rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) && (rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) === "false" && (rsp === null || rsp === void 0 ? void 0 : rsp.error) === "No active cart exists.") {
                    (0,helper.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency,
                            taxMode: "Platform"
                        };
                        dispatch((0,cartSlice/* createCart */.Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                        });
                    });
                } else if (rsp === null || rsp === void 0 ? void 0 : (ref = rsp.lineItems) === null || ref === void 0 ? void 0 : ref.length) {
                    dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                    const payload = {
                        actions: [
                            {
                                action: "recalculate",
                                updateProductData: true
                            }
                        ]
                    };
                    dispatch((0,cartSlice/* addToCart */.Xq)(payload));
                }
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (user && isAuth && config.orderHistoryUrl) {
            router.push(config.orderHistoryUrl);
        }
    }, [
        user,
        isAuth,
        config.orderHistoryUrl
    ]);
    const setInitialState = async (config)=>{
        const homeUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.homepageUrl", ""));
        const orderDetailsUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderDetailsPath", ""));
        const orderHistoryUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderHistoryPath", ""));
        setInitialConfig({
            homeUrl,
            orderDetailsUrl,
            orderHistoryUrl
        });
    };
    const redirect = (url)=>{
        router.push("".concat(url));
    };
    const showToastMessage = (payload)=>{
        dispatch((0,genericSlice/* showToast */.CF)(payload));
    };
    const findOrder = async (orderNo, email)=>{
        const res = await (0,orders/* fetchOrderDataByEmailOrderId */.lL)(email, orderNo);
        const { isEmailMatching , consumeFluentOrder , mainPayload ={} , results =[]  } = res;
        var ref;
        const { custom: { fields: { fraudChallengeStatus =""  } = {}  } = {}  } = (ref = results.find((o)=>{
            var ref, ref1;
            return (ref = o.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.isParentOrder;
        })) !== null && ref !== void 0 ? ref : {};
        if (consumeFluentOrder && !isEmailMatching) {
            return false;
        } else if (res) {
            if (!isEmpty_default()(mainPayload) || !isEmpty_default()(results)) {
                if (constants.FRAUD_CHLLENGE_STATUS.includes(fraudChallengeStatus)) {
                    return "showWarning";
                } else {
                    return await (0,utils/* getOrderDetailsUrl */.e1)(email, orderNo);
                }
            }
            return "showWarning";
        } else return false;
    };
    return !isEmpty_default()(i18n) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatus_view, {
        i18n: i18n,
        homeUrl: homeUrl,
        supportLine: contactNumber,
        cartcontactDetails: cartcontactDetails,
        findOrder: (orderNo, email)=>findOrder(orderNo, email),
        redirect: redirect,
        showToastMessage: showToastMessage
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatusFiller, {});
};
/* harmony default export */ var v1_OrderStatus = (OrderStatus_OrderStatus);

;// CONCATENATED MODULE: ./src/pages/orders/order-status.jsx










const OrderStatusPage = (param)=>{
    let { locale , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                orderStatus: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatus, {
                        data: data
                    }),
                orderStatusFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderStatusFiller, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var order_status = (OrderStatusPage);


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83699);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34326);


const getTranslations = function(t) {
    let authorData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        home: t("kf.orderStatus.label.home"),
        orderStatus: t("kf.orderStatus.label.orderStatus"),
        orderStatusDesc: t("kf.orderStatus.label.orderStatusDesc"),
        orderNo: t("kf.orderStatus.label.orderNo"),
        email: t("kf.orderStatus.label.email"),
        wheresOrderNo: t("kf.orderStatus.label.wheresOrderNo"),
        tooltipMssg: t("kf.orderStatus.label.tooltipMssg"),
        findMyOrder: t("kf.orderStatus.label.findMyOrder"),
        callSupport: t("kf.orderStatus.label.callSupport"),
        emptyOrderNo: t("kf.orderStatus.label.emptyOrderNo"),
        validOrderNo: t("kf.orderStatus.label.validOrderNo"),
        emptyEmail: t("kf.orderStatus.label.emptyEmail"),
        validEmail: t("kf.orderStatus.label.validEmail"),
        cantFindOrder: t("kf.orderStatus.label.cantFindOrder"),
        genError: t("kf.error.message.genericError"),
        orderWarningDesc1: t("kf.orderStatus.message.orderWarningDesc1"),
        orderWarningDesc2: t("kf.orderStatus.message.orderWarningDesc2"),
        orderWarningTitle: t("kf.orderStatus.label.orderWarningTitle"),
        orderWarningDesc1: t("kf.orderStatus.message.orderWarningDesc1"),
        orderWarningDesc2: t("kf.orderStatus.message.orderWarningDesc2"),
        orderWarningContinueCta: t("kf.orderStatus.button.orderWarningContinueCta"),
        home: t("kf.global.label.home"),
        order: t("kf.orderHistory.label.order"),
        orderDetails: t("kf.orderDetails.label.orderDetails"),
        orderPlacedOn: t("kf.orderDetails.label.orderPlacedOn"),
        customerInfo: t("kf.orderDetails.label.customerInfo"),
        contactInfo: t("kf.orderDetails.label.contactInfo"),
        shippingAddress: t("kf.orderDetails.label.shippingAddress"),
        paymentInfo: t("kf.orderDetails.label.paymentInfo"),
        billingAddress: t("kf.orderDetails.label.billingAddress"),
        endingIn: t("kf.orderDetails.label.endingIn"),
        expiry: t("kf.orderDetails.label.expiry"),
        print: t("kf.orderDetails.label.print"),
        downloadSpecs: t("kf.orderDetails.label.downloadSpecs"),
        needHelp: t("kf.orderDetails.label.needHelp"),
        supportDesc1: t("kf.orderDetails.label.supportDesc1"),
        returnPolicy: t("kf.orderDetails.label.returnPolicy"),
        or: t("kf.orderDetails.label.or"),
        productWarranty: t("kf.orderDetails.label.productWarranty"),
        supportDesc2: t("kf.orderDetails.label.supportDesc2"),
        callSupport: t("kf.orderDetails.label.callSupport"),
        orderSummary: t("kf.orderDetails.label.orderSummary"),
        subTotal: t("kf.orderDetails.label.subTotal"),
        totalPromotions: t("kf.orderDetails.label.totalPromotions"),
        shipping: t("kf.orderDetails.label.shipping"),
        taxes: t("kf.orderDetails.label.taxes"),
        orderTotal: t("kf.orderDetails.label.orderTotal"),
        orderStatus: t("kf.orderDetails.label.orderStatus"),
        orderNumber: t("kf.orderDetails.label.orderNumber"),
        qty: t("kf.cart.label.qty"),
        quantity: t("kf.checkout.label.quantity"),
        unitPrice: t("kf.cart.label.unitPrice"),
        total: t("kf.cart.label.total"),
        colorFinish: t("kf.cart.label.colorFinish"),
        parcelShipping: t("kf.orderDetails.label.parcelShipping"),
        freightShipping: t("kf.orderDetails.label.freightShipping"),
        parcelShippingDesc: (days)=>t("kf.orderDetails.label.parcelShippingDesc", {
                days
            }),
        freightShippingDesc: (days)=>t("kf.orderDetails.label.freightShippingDesc", {
                days
            }),
        registerProducts: t("kf.orderDetails.label.registerProducts"),
        createReturn: t("kf.orderDetails.label.createReturn"),
        tracking: t("kf.orderDetails.label.tracking"),
        allItemsCancelled: t("kf.orderDetails.label.allItemsCancelled"),
        fewItemsCancelled: t("kf.orderDetails.label.fewItemsCancelled"),
        note: t("kf.cart.label.note"),
        comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
        eDelivery: t("kf.cart.label.eDelivery"),
        eDeliveryDesc: (days)=>t("kf.cart.label.eDeliveryDesc", {
                days
            }),
        eDeliveryNote: t("kf.orderDetails.label.eDeliveryNote"),
        eDeliveryMsg: t("kf.orderDetails.label.eDeliveryMsg"),
        email: t("kf.orderConf.label.email"),
        viewPartsDiagram: t("kf.orderDetails.label.viewPartsDiagram"),
        noOrderFound: t("kf.orderConf.label.noOrderFound"),
        printAria: t("kf.orderDetails.label.printAria"),
        comboSkuDelivery: t("kf.orderDetails.label.comboSkuDelivery"),
        itemOf: (index, count)=>t("kf.orderDetails.label.itemOf", {
                index,
                count
            }),
        parcelTooltip: t("kf.orderDetails.label.parcelTooltip"),
        parcelShippingAriaLabel: t("kf.checkout.label.parcelShippingAriaLabel"),
        freightTooltip: t("kf.orderDetails.label.freightTooltip"),
        eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
        discountPercentage: t("kf.checkout.label.discountPercentage"),
        off: t("kf.cart.label.off"),
        ariaLabel: {
            partsDiagram: (product)=>t("kf.myProducts.aria.label.partsDiagram", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        openNewTabText: t("kf.share.label.openNewTabText"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        orders: t("kf.orderHistory.label.orders"),
        cancelled: t("kf.orderDetails.label.cancelled"),
        hi: t("kf.account.label.hi"),
        signOut: t("kf.account.label.signOut"),
        myAccount: t("kf.account.label.myAccount"),
        favorites: t("kf.account.label.favorites"),
        accountSettings: t("kf.account.label.accountSettings"),
        orders: t("kf.account.label.orders"),
        myProducts: t("kf.account.label.myProducts"),
        myServices: t("kf.account.label.myServices"),
        ariaSignOut: t("kf.loggedin.button.aria.signOut"),
        menuItems: (pageName)=>t("kf.account.aria.menuItems", {
                pageName
            }),
        order: t("kf.orderHistory.label.order"),
        orders: t("kf.orderHistory.label.orders"),
        openOrders: t("kf.orderHistory.label.openOrders"),
        pastOrders: t("kf.orderHistory.label.pastOrders"),
        customerServices: t("kf.orderHistory.label.customerServices"),
        orderPlacedOnHistory: t("kf.orderHistory.label.orderPlacedOn"),
        items: t("kf.orderHistory.label.items"),
        orderTotal: t("kf.orderHistory.label.orderTotal"),
        orderStatus: t("kf.orderHistory.label.orderStatus"),
        viewOrder: t("kf.orderHistory.label.viewOrder"),
        continueShopping: t("kf.orderHistory.label.continueShopping"),
        noOpenOrders: t("kf.orderHistory.label.noOpenOrders"),
        loading: t("kf.search.label.loading"),
        orderCreatedOn: (showOrdersFromLabel)=>showOrdersFromLabel ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.sanitizeDOMString)(showOrdersFromLabel) : t("kf.orderHistory.label.orderCreatedOn"),
        thankYouForOrder: t("kf.orderConf.label.thankYouForOrder"),
        freeShipping: t("kf.label.freeShipping"),
        orderConfMessage: t("kf.orderConf.label.orderConfMessage"),
        emailMessage: t("kf.orderConf.label.emailMessage"),
        orderConfirmation: t("kf.orderConf.label.orderConfirmation"),
        orderConfirmationNumber: t("kf.orderConf.label.orderConfirmationNumber"),
        email: t("kf.orderConf.label.email"),
        customerInfo: t("kf.orderDetails.label.customerInfo"),
        contactInfo: t("kf.orderDetails.label.contactInfo"),
        shippingAddress: t("kf.orderDetails.label.shippingAddress"),
        paymentInfo: t("kf.orderDetails.label.paymentInfo"),
        billingAddress: t("kf.orderDetails.label.billingAddress"),
        endingIn: t("kf.orderDetails.label.endingIn"),
        expiry: t("kf.orderDetails.label.expiry"),
        print: t("kf.orderDetails.label.print"),
        downloadSpecs: t("kf.orderDetails.label.downloadSpecs"),
        needHelp: t("kf.orderDetails.label.needHelp"),
        supportDesc: t("kf.orderDetails.label.supportDesc"),
        supportDesc1: t("kf.orderDetails.label.supportDesc1"),
        returnPolicy: t("kf.orderDetails.label.returnPolicy"),
        or: t("kf.orderDetails.label.or"),
        registerProducts: t("kf.orderDetails.label.registerProducts"),
        productWarranty: t("kf.orderDetails.label.productWarranty"),
        supportDesc2: t("kf.orderDetails.label.supportDesc2"),
        callSupport: t("kf.orderDetails.label.callSupport"),
        orderSummary: t("kf.orderDetails.label.orderSummary"),
        subTotal: t("kf.orderDetails.label.subTotal"),
        totalPromotions: t("kf.orderDetails.label.totalPromotions"),
        shipping: t("kf.orderDetails.label.shipping"),
        taxes: t("kf.orderDetails.label.taxes"),
        orderTotal: t("kf.orderDetails.label.orderTotal"),
        orderStatus: t("kf.orderDetails.label.orderStatus"),
        orderNumber: t("kf.orderDetails.label.orderNumber"),
        qty: t("kf.cart.label.qty"),
        quantity: t("kf.checkout.label.quantity"),
        unitPrice: t("kf.cart.label.unitPrice"),
        total: t("kf.cart.label.total"),
        colorFinish: t("kf.cart.label.colorFinish"),
        parcelShipping: t("kf.orderDetails.label.parcelShipping"),
        freightShipping: t("kf.orderDetails.label.freightShipping"),
        parcelShippingDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.parcelMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.parcelMessage.replace("{{days}}", days)) : t("kf.orderDetails.label.parcelShippingDesc", {
                days
            });
        },
        freightShippingDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.freightMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.freightMessage.replace("{{days}}", days)) : t("kf.orderDetails.label.freightShippingDesc", {
                days
            });
        },
        allItemsCancelled: t("kf.orderDetails.label.allItemsCancelled"),
        fewItemsCancelled: t("kf.orderDetails.label.fewItemsCancelled"),
        note: t("kf.cart.label.note"),
        comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
        eDelivery: t("kf.cart.label.eDelivery"),
        eDeliveryDesc: (days)=>{
            return (authorData === null || authorData === void 0 ? void 0 : authorData.eDeliveryMessage) ? (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oO)(authorData.eDeliveryMessage.replace("{{days}}", days)) : t("kf.cart.label.eDeliveryDesc", {
                days
            });
        },
        eDeliveryNote: t("kf.orderDetails.label.eDeliveryNote"),
        eDeliveryMsg: t("kf.orderDetails.label.eDeliveryMsg"),
        viewPartsDiagram: t("kf.orderDetails.label.viewPartsDiagram"),
        printAria: t("kf.orderDetails.label.printAria"),
        comboSkuDelivery: t("kf.orderDetails.label.comboSkuDelivery"),
        parcelShippingAriaLabel: t("kf.checkout.label.parcelShippingAriaLabel"),
        itemOf: (index, count)=>t("kf.orderDetails.label.itemOf", {
                index,
                count
            }),
        parcelTooltip: t("kf.orderDetails.label.parcelTooltip"),
        freightTooltip: t("kf.orderDetails.label.freightTooltip"),
        eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
        discountPercentage: t("kf.checkout.label.discountPercentage"),
        off: t("kf.cart.label.off"),
        openNewTabText: t("kf.share.label.openNewTabText"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        cancelled: t("kf.orderDetails.label.cancelled"),
        childOrderStatus: t("kf.orderDetails.label.childOrderStatus"),
        productDiscounts: t("kf.cart.label.productDiscounts"),
        shipmentOf: (number, total)=>t("kf.orderDetails.label.shipmentOf", {
                number,
                total
            }),
        homeowner: t("kf.auth.label.homeOwner"),
        professional: t("kf.auth.label.professional"),
        viewOrderDetails: t("kf.orderHistory.label.viewOrder"),
        createPassword: t("kf.account.label.createPassword"),
        password: t("kf.account.label.password"),
        passwordRequirements: t("kf.auth.label.passwordRequirements"),
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        characterCount: t("kf.auth.label.characterCount"),
        uppercaseLetter: t("kf.auth.label.uppercaseLetter"),
        lowercaseLetter: t("kf.auth.label.lowercaseLetter"),
        symbolValidation: t("kf.auth.label.symbolValidation"),
        numberValidation: t("kf.auth.label.numberValidation"),
        pwMustInclude: t("kf.auth.label.pwMustInclude"),
        accountType: t("kf.account.label.accountType"),
        passwordError: t("kf.auth.error.passwordError"),
        passwordProvideError: t("kf.auth.label.provide.pwdError"),
        accountCreationWelcomeAria: t("kf.auth.label.welcomeAria"),
        backToTop: t("kf.favorite.label.backToTop"),
        view: "View",
        all: "All",
        loadMore: "Load More",
        items: t("kf.plp.items"),
        yourKohlerAccount: t("kf.auth.label.yourKohlerAccount"),
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        checkOrder: t("kf.orderStatus.label.checkOrder"),
        orderID: t("kf.orderStatus.label.orderID"),
        noResult: t("kf.orderStatus.label.noResult")
    };
};


/***/ }),

/***/ 84219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lL": function() { return /* binding */ orders_fetchOrderDataByEmailOrderId; },
  "KV": function() { return /* binding */ fetchOrderDataByOrderId; },
  "AU": function() { return /* binding */ orders_fetchOrders; },
  "K0": function() { return /* binding */ orders_setMenu; }
});

// UNUSED EXPORTS: getCardDetails

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./store/features/orderSlice.js
var orderSlice = __webpack_require__(76977);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store_0 = __webpack_require__(45094);
;// CONCATENATED MODULE: ./src/utils/orders.js






const getCardDetails = async (param)=>{
    let { url , cardId  } = param;
    try {
        var ref;
        const serviceList = await aemAxiosInstance({
            url: GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: url
            }
        });
        if (serviceList === null || serviceList === void 0 ? void 0 : (ref = serviceList.data) === null || ref === void 0 ? void 0 : ref.cardTypes) {
            var ref1;
            const cardTypesList = await aemAxiosInstance({
                url: GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: serviceList === null || serviceList === void 0 ? void 0 : (ref1 = serviceList.data) === null || ref1 === void 0 ? void 0 : ref1.cardTypes
                }
            });
            if (cardTypesList && cardTypesList.data) {
                var ref2, ref3;
                var ref4;
                const cardValueText = (ref4 = (ref3 = cardTypesList === null || cardTypesList === void 0 ? void 0 : (ref2 = cardTypesList.data) === null || ref2 === void 0 ? void 0 : ref2.find((card)=>card.value === cardId)) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref4 !== void 0 ? ref4 : "";
                return cardValueText;
            } else {
            // log.error(
            //   "Card Details: Error occured while fetching data from AEM"
            // )
            }
        }
    } catch (error) {
    // log.error(error)
    }
};
const setMenu = (info, i18n)=>{
    const { accountSettingsPath , myFavoritesPagePath , orderHistoryPath , myProductsPath , myServicesPath  } = info;
    const urlsAndTitles = [
        {
            url: accountSettingsPath,
            title: i18n.accountSettings
        },
        {
            url: myFavoritesPagePath,
            title: i18n.favorites
        },
        {
            url: orderHistoryPath,
            title: i18n.orders
        },
        {
            url: myProductsPath,
            title: i18n.myProducts
        },
        {
            url: myServicesPath,
            title: i18n.myServices
        }
    ];
    return urlsAndTitles.filter((param)=>{
        let { url  } = param;
        return url;
    }).map((param)=>{
        let { url , title  } = param;
        return {
            title,
            url
        };
    });
};
const getDaysDifference = (orderDate)=>{
    const currentDate = new Date();
    const timeDiff = orderDate.getTime() - currentDate.getTime();
    const daysDiff = timeDiff / TotalSecsForaDay;
    return daysDiff;
};
const fetchOrders = async ()=>{
    // #ToDo Make loading true
    const openOrders = [];
    const pastOrders = [];
    let postOrdersForUpsell = [];
    const openData = await store.dispatch(getOpenOrders()).unwrap().then((response)=>response);
    const pastData = await store.dispatch(getPastOrders()).unwrap().then((response)=>response);
    openData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(_get(order, "createdAt", ""));
        const openDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        openOrders.push({
            orderNo: _get(order, "orderNumber", ""),
            totalItems: openDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: _get(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(_get(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < postOrderNoOfDays ? lineItemsData : []
        });
    });
    pastData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(_get(order, "createdAt", ""));
        const pastDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        pastOrders.push({
            orderNo: _get(order, "orderNumber", ""),
            totalItems: pastDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: _get(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(_get(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < postOrderNoOfDays ? lineItemsData : []
        });
    });
    const placedOrders = openOrders.concat(pastOrders);
    if (placedOrders.length) {
        postOrdersForUpsell = placedOrders.filter((item)=>item.orderStatus !== "Cancelled").map((item)=>item.lineItems).flat(1);
    }
    return {
        openOrders,
        pastOrders,
        postOrdersForUpsell
    };
};
/**
 *
 * @param {String} email
 * @param {String} orderNo
 * @return {String} order details page url
 */ const fetchOrderDataByEmailOrderId = async (email, orderNo)=>{
    return await store.dispatch(findOrderByEmail({
        orderNo,
        email
    })).unwrap().then((response)=>response);
};

;// CONCATENATED MODULE: ./utils/orders.js





const orders_getCardDetails = async (param)=>{
    let { url , cardId  } = param;
    try {
        var ref;
        const serviceList = await aemAxiosInstance({
            url: GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: url
            }
        });
        if (serviceList === null || serviceList === void 0 ? void 0 : (ref = serviceList.data) === null || ref === void 0 ? void 0 : ref.cardTypes) {
            var ref1;
            const cardTypesList = await aemAxiosInstance({
                url: GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: serviceList === null || serviceList === void 0 ? void 0 : (ref1 = serviceList.data) === null || ref1 === void 0 ? void 0 : ref1.cardTypes
                }
            });
            if (cardTypesList && cardTypesList.data) {
                var ref2, ref3;
                var ref4;
                const cardValueText = (ref4 = (ref3 = cardTypesList === null || cardTypesList === void 0 ? void 0 : (ref2 = cardTypesList.data) === null || ref2 === void 0 ? void 0 : ref2.find((card)=>card.value === cardId)) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref4 !== void 0 ? ref4 : "";
                return cardValueText;
            } else {
            // log.error(
            //   "Card Details: Error occured while fetching data from AEM"
            // )
            }
        }
    } catch (error) {
    // log.error(error)
    }
};
const orders_setMenu = (info, i18n)=>{
    const { accountSettingsPath , myFavoritesPagePath , orderHistoryPath  } = info;
    const data = [
        {
            title: i18n.accountSettings,
            url: accountSettingsPath
        },
        {
            title: i18n.favorites,
            url: myFavoritesPagePath
        },
        {
            title: i18n.orders,
            url: orderHistoryPath
        }
    ];
    return data;
};
const orders_fetchOrders = async function() {
    let offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, fetchOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, fetchPast = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    // #ToDo Make loading true
    const openOrders = [];
    const pastOrders = [];
    let openOrdersTotal = 0;
    let pastOrdersTotal = 0;
    if (fetchOpen) {
        const { total , results: openData  } = await store_0/* store.dispatch */.h.dispatch((0,orderSlice/* getOpenOrders */.x0)(offset)).unwrap().then((response)=>response);
        openOrdersTotal = total;
        openData.forEach((order)=>{
            var ref, ref1, ref2;
            const orderDate = new Date(get_default()(order, "createdAt", ""));
            let openDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                var ref, ref1;
                return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
            });
            if (order === null || order === void 0 ? void 0 : (ref1 = order.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.isImported) {
                var ref3;
                openDataArr = [
                    ...openDataArr,
                    ...order === null || order === void 0 ? void 0 : (ref3 = order.customLineItems) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>{
                        var ref, ref1;
                        return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
                    })
                ];
            }
            openOrders.push({
                orderNo: get_default()(order, "orderNumber", ""),
                totalItems: openDataArr.reduce((a, b)=>{
                    return a + b.quantity;
                }, 0),
                orderStatus: get_default()(order, "state.obj.name.en", ""),
                orderDate: "".concat(orderDate.toLocaleString("default", {
                    month: "long"
                }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
                orderTotal: Number(get_default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
                isImported: get_default()(order, "custom.fields.isImported", false),
                migratedOrderDate: get_default()(order, "custom.fields.orderCreatedAt", "")
            });
        });
    }
    if (fetchPast) {
        const { total: total1 , results: pastData  } = await store_0/* store.dispatch */.h.dispatch((0,orderSlice/* getPastOrders */.rx)(offset)).unwrap().then((response)=>response);
        pastOrdersTotal = total1;
        pastData.forEach((order)=>{
            var ref, ref1, ref2;
            const orderDate = new Date(get_default()(order, "createdAt", ""));
            let pastDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                var ref, ref1;
                return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
            });
            if (order === null || order === void 0 ? void 0 : (ref1 = order.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.isImported) {
                var ref3;
                pastDataArr = [
                    ...pastDataArr,
                    ...order === null || order === void 0 ? void 0 : (ref3 = order.customLineItems) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>{
                        var ref, ref1;
                        return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
                    })
                ];
            }
            pastOrders.push({
                orderNo: get_default()(order, "orderNumber", ""),
                totalItems: pastDataArr.reduce((a, b)=>{
                    return a + b.quantity;
                }, 0),
                orderStatus: get_default()(order, "state.obj.name.en", ""),
                orderDate: "".concat(orderDate.toLocaleString("default", {
                    month: "long"
                }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
                orderTotal: Number(get_default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
                isImported: get_default()(order, "custom.fields.isImported", false),
                migratedOrderDate: get_default()(order, "custom.fields.orderCreatedAt", "")
            });
        });
    }
    return {
        openOrders,
        openOrdersTotal,
        pastOrders,
        pastOrdersTotal
    };
};
const orders_fetchOrderDataByEmailOrderId = async function(email, orderNo) {
    let source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return await store_0/* store.dispatch */.h.dispatch((0,orderSlice/* findOrderByEmail */.Jv)({
        orderNo,
        email,
        source
    })).unwrap().then((response)=>response);
};
const fetchOrderDataByOrderId = async (orderNo)=>{
    return await store_0/* store.dispatch */.h.dispatch((0,orderSlice/* findOrderByOrderID */.se)({
        orderNo
    })).unwrap().then((response)=>response);
};



/***/ }),

/***/ 1493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountTabsWrapper":"AccountsLayoutNonLoggedIn_accountTabsWrapper__8c0gO"};

/***/ }),

/***/ 96012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"orderStatusWrapper":"v1_orderStatusWrapper__honwG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,1433,6051,9774,2888,179], function() { return __webpack_exec__(82904); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);